module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "/static/css/digiteka.css",
      "type": "text/css",
      "media": "all"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-form col-md-8 center-block",
    staticStyle: {
      "float": "none"
    }
  }, [_c('h1', [_vm._v("Login on Media Platform")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    staticClass: "form-control btn-full-width",
    attrs: {
      "placeholder": "Email",
      "type": "email",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control btn-full-width",
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors),
      expression: "errors"
    }],
    staticClass: "errors"
  }, [_vm._v("\n          ⚠\n          " + _vm._s(_vm.errors) + "\n        ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Log in")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68779255"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DigitekaLogin.vue
// module id = 1052
// module chunks = 1